import * as n from "react";
import { useWindowSize as h } from "./use-window-size.mjs";
const c = (e) => {
  if (!e.hasChildNodes()) return e;
  const t = e.childNodes[0];
  return (t == null ? void 0 : t.nodeType) === 3 ? e : t ? c(t) : e;
}, a = (e, t) => {
  const [u, f] = n.useState(void 0), { width: d } = h();
  return n.useLayoutEffect(() => {
    const { current: s } = e, o = () => {
      const r = c(s);
      if (!r) return;
      const i = r.scrollWidth > s.clientWidth;
      f(i), t && t(i);
    };
    if (s) {
      const r = new MutationObserver(() => {
        o();
      });
      return r.observe(s, { childList: !0, subtree: !0, characterData: !0 }), o(), () => r.disconnect();
    }
  }, [t, e, d]), u;
};
export {
  a as useIsOverflowText
};
